import Seo from "@/components/Seo";
import { LEGAL_PAGES } from "@/data/content";

export default function LegalPage({ pageKey }) {
  const page = LEGAL_PAGES[pageKey];
  if (!page) return null;

  return (
    <main data-testid={`legal-page-${pageKey}`} className="pt-28 md:pt-36 pb-24">
      <Seo title={`${page.title} – JINSU`} description={page.meta} />

      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <p className="eyebrow text-water-deep/80">JINSU</p>
        <h1 className="font-heading mt-5 font-semibold text-foreground leading-tight" style={{ fontSize: "clamp(2rem, 4vw + 0.6rem, 3.6rem)" }} lang="fi">
          {page.title}
        </h1>

        <div className="mt-12 space-y-10">
          {page.sections.map((s, i) => (
            <section key={i} data-testid={`legal-${pageKey}-section-${i}`}>
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground">
                {s.heading}
              </h2>
              <div className="mt-4 space-y-3 text-sm md:text-base leading-relaxed text-muted-foreground">
                {s.paragraphs.map((p, j) => (
                  <p key={j}>{p}</p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
